import MapBoxDraw from '@mapbox/mapbox-gl-draw';
import circle from '@turf/circle';
import { extend } from 'lodash';

const CircleMode = extend({}, MapBoxDraw.modes.draw_polygon);
const DEFAULT_RADIUS_IN_M = 2000;

CircleMode.onSetup = function (opts) {
    const polygon = this.newFeature({
        type: constants.geojsonTypes.FEATURE,
        properties: {
            isCircle: true,
            center: []
        },
        geometry: {
            type: constants.geojsonTypes.POLYGON,
            coordinates: [[]]
        }
    });

    this.addFeature(polygon);
    this.clearSelectedFeatures();
    MapBoxDraw.lib.doubleClickZoom.disable(this);
    this.updateUIClasses({ mouse: constants.cursors.ADD });
    this.activateUIButton(constants.types.POLYGON);
    this.setActionableState({
        trash: true
    });

    return {
        initialRadius: opts.initialRadius || DEFAULT_RADIUS_IN_M,
        polygon,
        currentVertexPosition: 0
    };
};

CircleMode.clickAnywhere = function (state, e) {
    if (state.currentVertexPosition === 0) {
        state.currentVertexPosition++;
        const center = [e.lngLat.lng, e.lngLat.lat];
        const circleFeature = circle(center, state.initialRadius, {
            units: 'meters'
        });
        state.polygon.incomingCoords(circleFeature.geometry.coordinates);
        state.polygon.properties.center = center;
        state.polygon.properties.radius = state.initialRadius;
    }
    return this.changeMode(constants.modes.SIMPLE_SELECT, {
        featureIds: [state.polygon.id]
    });
};

export default CircleMode;
